import {isLastElement} from "@Array/isLastElement";
import useCreateSelectedVehicleDescription
    from "@CheckOrder/features/addons/features/jadrolinija/features/selectedVehicleAddon/hooks/useCreateSelectedVehicleDescription";
import VehicleAddonType from "@CheckOrder/types/VehicleAddon.type";

type VehicleAddonInfoProps = {
    vehicle: VehicleAddonType,
    className?: string,
}

function VehicleAddonInfo({vehicle, className = "selected-addon__info"}: VehicleAddonInfoProps) {
    const infoDescriptions = useCreateSelectedVehicleDescription(vehicle)

    return (
        <div className={className}>
            {infoDescriptions.map((info, index) => (
                <>
                    {info}
                    {!isLastElement(infoDescriptions, index) && (
                        <br/>
                    )}
                </>
            ))}
        </div>
    )
}

export default VehicleAddonInfo